<template>
    <NoDataScreen v-if="noDataScreen"/>
    <DataTable v-else
    :columns="tableHeader"
    :rows="data"
    :totalPages="totalPages"
    @changeData="change_page"
    @changePerPage="change_pagination"
    @downloadData="downloadData"
    />
  </template>

  <script>

  import { mapState, mapActions } from 'vuex'
  import DataTable from '../../components/Table/Table.vue'
  import NoDataScreen from '../../components/Table/TableNoDataScreen.vue'

  export default {
    name: 'ResultHydrological',

    data () {
      return {
        returnTo: '/resultHydrological'
      }
    },

    components: {
      DataTable,
      NoDataScreen
    },

    computed: {
      ...mapState(['tableHeader', 'data', 'totalPages', 'noDataScreen'])
    },

    methods: {
      ...mapActions(['Change_page', 'queryHidrometeorologicalData', 'Change_perPage', 'downloadXlsxData']),

      change_page(page_number){
        this.Change_page(page_number)
        this.queryHidrometeorologicalData()
      },
      change_pagination(quantity) {
        this.Change_perPage(quantity)
        this.queryHidrometeorologicalData()
      },
      downloadData(){
        this.downloadXlsxData()
      }
    },
  }
  </script>